import {
  TextPatternScannerUiResult,
  mapRTUUIResult,
  withSBErrorHandling,
  type ResultWrapper,
  type TextPatternScannerScreenConfiguration,
} from '../types';

import { ScanbotSDKPlugin } from './Definitions';

/**
 * @internal
 * @hidden
 */
export const ScanbotTextPatternImpl = {
  async startScanner(
    configuration: TextPatternScannerScreenConfiguration,
  ): Promise<ResultWrapper<TextPatternScannerUiResult>> {
    return withSBErrorHandling(async () =>
      mapRTUUIResult<TextPatternScannerUiResult>(
        await ScanbotSDKPlugin.startTextPatternScanner(configuration),
        TextPatternScannerUiResult,
      ),
    );
  },
};
